<div class="form-wrapper" ondragstart="return false">
	<div class="main-form">
		<app-main-hallpass-form></app-main-hallpass-form>
	</div>
</div>
